export const BUILD = {
    version: '3.14.11',
    date: 'Mon Mar 06 2023 14:18:56 GMT+0000 (Coordinated Universal Time)'
};
//# sourceMappingURL=build.js.map